import { __assign } from "tslib";
export var ListTheme = function (theme) { return ({
    defaultProps: {},
    styleOverrides: {
        root: function (_a) {
            var ownerState = _a.ownerState, theme = _a.theme;
            return (__assign({}, (ownerState.size === 'large' && {
                '.MuiListCell-root': {
                    padding: theme.spacing(2),
                },
            })));
        },
    },
}); };
export default ListTheme;
//# sourceMappingURL=theme.js.map